import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  TextField,
} from "../../../../components";

export default function ConfiguracoesTefDialog({
  open,
  setOpen,
  configuracoesTef,
  atualizarIniFileInfo
}) {
  const [config, setConfig] = useState({});

  useEffect(() => {
    if (open) {
      setConfig({ ...configuracoesTef });
    }
  }, [open]);

  const onChangeInput = (event) => {
    const { name, value } = event.target;
    console.log(config);
    setConfig((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleSalvar = async () => {
    await atualizarIniFileInfo(config);
    handleCloseDialog();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      PaperComponent="div"
      open={open}
      aria-labelledby="form-dialog-title"
      onClose={handleCloseDialog}
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title="Configurações TEF" />
          <CardContent className="p-3">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="codigo"
                  name="codigo"
                  label="Código da empresa"
                  value={config?.codigo}
                  onChange={onChangeInput}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="enderecoIP"
                  name="enderecoIP"
                  label="Endereço IP"
                  value={config?.enderecoIP}
                  onChange={onChangeInput}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="numeroTerminal"
                  name="numeroTerminal"
                  label="Número terminal"
                  value={config?.numeroTerminal}
                  onChange={onChangeInput}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="impressora"
                  name="impressora"
                  label="Impressora"
                  value={config?.impressora}
                  onChange={onChangeInput}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="portaPinpad"
                  name="portaPinpad"
                  label="Porta pinpad"
                  value={config?.portaPinpad}
                  onChange={onChangeInput}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button variant="contained" disableElevation onClick={handleSalvar}>
              <i
                className="ph-fill ph-check-circle"
                style={{ color: "white", fontSize: 22, marginRight: 10 }}
              ></i>
              Salvar
            </Button>
            <Button
              color="inherit"
              variant="contained"
              disableElevation
              onClick={handleCloseDialog}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              />
              Fechar
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
